import http from '../../utils/fetch'

export default {
    baseurl: '/api/swyl/v1/dscCostReduction/grossMargin',
    // 分页查询
    selectPage(f) {
        return http({
            url: this.baseurl + '/selectPage',
            method: 'post',
            data: f
        });
    },
    // 手动触发毛利率计算
    triggerGrossMargin(statMonth) {
        return http({
            url: this.baseurl + '/triggerGrossMargin',
            method: 'post',
            params: { statMonth: statMonth }
        });
    },
    // 修复历史拆分
    repairReductionSplit(statYear) {
        return http({
            url: this.baseurl + '/repairReductionSplit',
            method: 'post',
            params: { statYear: statYear }
        });
    },
    // 导出
    downloadExcel(f) {
        return http({
            url: this.baseurl + '/downloadExcel',
            method: 'get',
            params: f,
            responseType: 'blob'
        });
    },
}
